/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EdictTransferOutcome } from './EdictTransferOutcome';
import {
    EdictTransferOutcomeFromJSON,
    EdictTransferOutcomeFromJSONTyped,
    EdictTransferOutcomeToJSON,
    EdictTransferOutcomeToJSONTyped,
} from './EdictTransferOutcome';

/**
 * 
 * @export
 * @interface EdictTransferResponse
 */
export interface EdictTransferResponse {
    /**
     * 
     * @type {string}
     * @memberof EdictTransferResponse
     */
    clientId: string;
    /**
     * 
     * @type {string}
     * @memberof EdictTransferResponse
     */
    srvProceedingId: string;
    /**
     * 
     * @type {boolean}
     * @memberof EdictTransferResponse
     */
    proceedingCreated: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EdictTransferResponse
     */
    openingDateSet: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EdictTransferResponse
     */
    openingDateInEdict: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EdictTransferResponse
     */
    fileNumberSet: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EdictTransferResponse
     */
    courtSet: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EdictTransferResponse
     */
    offeredQuotaSet: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EdictTransferResponse
     */
    counselingTypeSet: boolean;
    /**
     * 
     * @type {EdictTransferOutcome}
     * @memberof EdictTransferResponse
     */
    hearing: EdictTransferOutcome;
    /**
     * 
     * @type {EdictTransferOutcome}
     * @memberof EdictTransferResponse
     */
    hearingCaseNote: EdictTransferOutcome;
    /**
     * 
     * @type {EdictTransferOutcome}
     * @memberof EdictTransferResponse
     */
    assignment: EdictTransferOutcome;
}



/**
 * Check if a given object implements the EdictTransferResponse interface.
 */
export function instanceOfEdictTransferResponse(value: object): value is EdictTransferResponse {
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('srvProceedingId' in value) || value['srvProceedingId'] === undefined) return false;
    if (!('proceedingCreated' in value) || value['proceedingCreated'] === undefined) return false;
    if (!('openingDateSet' in value) || value['openingDateSet'] === undefined) return false;
    if (!('openingDateInEdict' in value) || value['openingDateInEdict'] === undefined) return false;
    if (!('fileNumberSet' in value) || value['fileNumberSet'] === undefined) return false;
    if (!('courtSet' in value) || value['courtSet'] === undefined) return false;
    if (!('offeredQuotaSet' in value) || value['offeredQuotaSet'] === undefined) return false;
    if (!('counselingTypeSet' in value) || value['counselingTypeSet'] === undefined) return false;
    if (!('hearing' in value) || value['hearing'] === undefined) return false;
    if (!('hearingCaseNote' in value) || value['hearingCaseNote'] === undefined) return false;
    if (!('assignment' in value) || value['assignment'] === undefined) return false;
    return true;
}

export function EdictTransferResponseFromJSON(json: any): EdictTransferResponse {
    return EdictTransferResponseFromJSONTyped(json, false);
}

export function EdictTransferResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EdictTransferResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'clientId': json['clientId'],
        'srvProceedingId': json['srvProceedingId'],
        'proceedingCreated': json['proceedingCreated'],
        'openingDateSet': json['openingDateSet'],
        'openingDateInEdict': json['openingDateInEdict'],
        'fileNumberSet': json['fileNumberSet'],
        'courtSet': json['courtSet'],
        'offeredQuotaSet': json['offeredQuotaSet'],
        'counselingTypeSet': json['counselingTypeSet'],
        'hearing': EdictTransferOutcomeFromJSON(json['hearing']),
        'hearingCaseNote': EdictTransferOutcomeFromJSON(json['hearingCaseNote']),
        'assignment': EdictTransferOutcomeFromJSON(json['assignment']),
    };
}

export function EdictTransferResponseToJSON(json: any): EdictTransferResponse {
    return EdictTransferResponseToJSONTyped(json, false);
}

export function EdictTransferResponseToJSONTyped(value?: EdictTransferResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientId': value['clientId'],
        'srvProceedingId': value['srvProceedingId'],
        'proceedingCreated': value['proceedingCreated'],
        'openingDateSet': value['openingDateSet'],
        'openingDateInEdict': value['openingDateInEdict'],
        'fileNumberSet': value['fileNumberSet'],
        'courtSet': value['courtSet'],
        'offeredQuotaSet': value['offeredQuotaSet'],
        'counselingTypeSet': value['counselingTypeSet'],
        'hearing': EdictTransferOutcomeToJSON(value['hearing']),
        'hearingCaseNote': EdictTransferOutcomeToJSON(value['hearingCaseNote']),
        'assignment': EdictTransferOutcomeToJSON(value['assignment']),
    };
}

